import { get } from 'lodash';
import { queryClient } from 'src/configs/queryClient';
import { QUERY_KEY_USAGE } from 'src/services/queries';
import { LIST_FEATURES } from 'src/utils/constants/featuresPoint';
import { ERROR_CODE } from 'src/utils/constants/statusCode';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import { IUsageInformation } from 'src/utils/typings/response/payment';

export const useGetPointsFeature = (
  featureId: keyof typeof LIST_FEATURES,
  action: string,
  dataUsage?: IResponse<IUsageInformation>,
) => {
  const usageInfo = dataUsage
    ? dataUsage
    : (queryClient.getQueryData([QUERY_KEY_USAGE]) as IResponse<IUsageInformation>);

  const listFeatures = getArrayDefault(usageInfo?.data?.features);
  const featureSelected = listFeatures.find((feature) => feature.feature_type_name === featureId);
  return {
    planName: usageInfo?.status_code === ERROR_CODE.NOT_FOUND ? undefined : usageInfo?.data?.current_product, // planName === undefined => Users haven't bought plans yet.
    creditCosts: get(featureSelected, action, 0),
  };
};

export const useGetRemainCredit = () => {
  const usageInfoFromCache = queryClient.getQueryData([QUERY_KEY_USAGE]) as IResponse<IUsageInformation>;
  return Number(usageInfoFromCache?.data?.usage_total) - Number(usageInfoFromCache?.data?.current_usage);
};
